// //import { MainService } from '../service.service';

import { DgHubClientService } from "../dg-hub-client.service";

// import * as moment from 'moment';
export class LoggerService
{
    private static _service:DgHubClientService

    static init(service:DgHubClientService)
    {
        LoggerService._service = service;
    }

    static logError(e)
    {

        // LoggerService._service.oxClient.Error(e).then(v=>{
        //      //console.log(e);
        // })
        //console.log(e);
    }


    static logActivity(a)
    {

        // LoggerService._service.oxClient.Log(a).then(v=>{
        //      //console.log(a);
        // })

    }

    static activityMessage(name:string, message:string, source?:any)
    {

        // let sourceStr = (source)?`: ${source}`:"";
        // let messageStr = `${name} ${moment().format("YYYY-MM-DD HH:mm:ss z")}: ${message} ${sourceStr}`;
        // LoggerService.logActivity(messageStr)

    }

}
